<template>
  <v-container class="container--large glossary padding-left-right">
    <v-row class="pt-6 mb-12" align="center">
      <navigation-breadcrumb :items="breadcrumbItems" />
    </v-row>

    <GlossaryHeader
      :is-expand-all="!expandedItems.length"
      @expand-all="expandAll"
    />

    <GlossarySearch />

    <GlossaryItems
      v-if="!glossaryLoading"
      :expanded-items.sync="expandedItems"
    />
    <GlossarySkeletonPanels v-else />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationBreadcrumb from '../../components/NavigationBreadcrumb.vue';
import { GLOSSARY_BREADCRUMBS, SEGMENT_EVENTS } from '../../constants';
import GlossaryHeader from './GlossaryHeader.vue';
import GlossarySkeletonPanels from './GlossarySkeletonPanels.vue';
import GlossarySearch from './GlossarySearch.vue';
import GlossaryItems from './GlossaryItems.vue';
import GlossaryMixin from '../../mixins/glossary.mixin';

export default {
  mixins: [GlossaryMixin],
  components: {
    NavigationBreadcrumb,
    GlossaryHeader,
    GlossarySkeletonPanels,
    GlossarySearch,
    GlossaryItems,
  },
  data: () => ({
    breadcrumbItems: GLOSSARY_BREADCRUMBS,
    expandedItems: [],
  }),
  computed: {
    ...mapGetters(['glossarySearch']),
  },
  methods: {
    expandAll() {
      let searchType = 'All';
      if (this.glossarySearch) {
        searchType = 'Keyword';
        if (this.glossarySearchIsLetter) {
          searchType = 'Letter';
        }
      }
      if (!this.expandedItems.length) {
        const allContents = this.mx$glossaryItems.flatMap(
          ({ contents }) => contents
        );
        this.expandedItems = Array.from(Array(allContents.length).keys());
        window.analytics.track(SEGMENT_EVENTS.EXPAND_GLOSSARY_ALL_ITEMS, {
          contentType: 'Glossary',
          searchType: searchType,
          searchValue: this.glossarySearch,
        });
      } else {
        this.expandedItems = [];
        window.analytics.track(SEGMENT_EVENTS.COLLAPSE_GLOSSARY_ALL_ITEMS, {
          contentType: 'Glossary',
          searchType: searchType,
          searchValue: this.glossarySearch,
        });
      }
    },
  },
};
</script>
